import { render } from "./brandTile.vue?vue&type=template&id=02b5cfee"
import script from "./brandTile.vue?vue&type=script&lang=js"
export * from "./brandTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__